/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { ShortenerActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        shorteners: state.shorteners
    });
}

function mapDispatchToProps(dispatch) {
    return {
        getShorteners: () => {
            dispatch(ShortenerActions.fetchShorteners());
        },
        getShortener: (id) => {
            dispatch(ShortenerActions.fetchShortener(id));
        },
        updateShortener: (shortener) => {
            dispatch(ShortenerActions.updateShortener(shortener));
        },
        reauthorizeShortener: (shortener) => {
            dispatch(ShortenerActions.reauthorizeShortener(shortener));
        },
        deleteShortener: (id) => {
            dispatch(ShortenerActions.deleteShortener(id));
        },
        createShortener: (shortener) => {
            dispatch(ShortenerActions.createShortener(shortener));
        },
        setDefaultShortener: (id) => {
            dispatch(ShortenerActions.setDefaultShortener(id));
        },
        applyShortener: (id, type) => {
            dispatch(ShortenerActions.applyShortener(id, type));
        },
        getShortenerLog: (id) => {
            dispatch(ShortenerActions.fetchShortenerLog(id));
        },
        testShortener: (id) => {
            dispatch(ShortenerActions.fetchShortenerTest(id));
        }
	};
}

export default function ShortenerProvider(Component) {

    class ShortenerProvider extends React.Component {
        constructor(props) {
            super(props);

            this.findShortener = this.findShortener.bind(this);

        }

        findShortener(id) {
            let shortener = null;

            for (let i = 0; i < this.props.shorteners.length; ++i) {
                if (parseInt(this.props.shorteners[i].id, 10) === parseInt(id, 10)) {
                    shortener = this.props.shorteners[i];
                    break;
                }
            }

            return shortener;

        }

        render() {
            return (
                <Component
                    findShortener={this.findShortener}
                    {...this.props}/>
            );
        }
    }

    ShortenerProvider.displayName = "ShortenerProvider";

    return connect(mapStateToProps, mapDispatchToProps)(ShortenerProvider);
};
